import React from 'react';
import Candlestick3D from './Candlestick3D.js';
import { useTheme } from '../context/ThemeContext.js';

const Hero = () => {
  const { isLight } = useTheme();

  const scrollToServices = () => {
    document.getElementById('quant-research')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen w-full pt-20 sm:pt-28 pb-12 sm:pb-24 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">

          {/* TEXT */}
          <div className="lg:col-span-5 flex flex-col gap-6 sm:gap-10 items-start order-2 lg:order-1">

            <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
              <div className={`w-1.5 h-1.5 rounded-full ${
                isLight ? 'bg-primary shadow-[0_0_8px_#5e19e6]' : 'bg-accent shadow-[0_0_8px_#00f0ff]'
              }`} />
              <span className={`text-[9px] sm:text-[10px] font-mono uppercase tracking-widest ${
                isLight ? 'text-primary' : 'text-accent'
              }`}>
                Market Intelligence Core
              </span>
            </div>

            <h1 className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.1] mb-6 ${
              isLight ? 'text-gray-900' : 'text-white'
            }`}>
              Quantitative <br />
              <span className={`font-bold text-transparent bg-clip-text bg-gradient-to-r ${
                isLight ? 'from-gray-900 via-gray-500 to-gray-300' : 'from-white via-white/70 to-white/20'
              }`}>
                Intelligence Solutions.
              </span>
            </h1>

            <p className={`text-base sm:text-lg md:text-xl font-light leading-relaxed max-w-[65ch] ${
              isLight ? 'text-gray-500' : 'text-white/60'
            }`}>
              Quantitative research, market intelligence, and education — engineered for the modern era.
            </p>

            <div className="flex items-center gap-4 sm:gap-8 pt-2">
              <button
                onClick={scrollToServices}
                className={`group flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 sm:py-3 border rounded-lg text-xs sm:text-sm font-mono uppercase tracking-widest transition-all ${
                  isLight
                    ? 'bg-primary/10 border-primary/30 text-primary hover:bg-primary hover:text-white'
                    : 'bg-accent/10 border-accent/30 text-accent hover:bg-accent hover:text-black'
                }`}
              >
                <span>Explore Services</span>
                <span className="material-symbols-outlined text-sm group-hover:translate-x-1 transition-transform">arrow_forward</span>
              </button>
            </div>
          </div>

          {/* CHART */}
          <div className="lg:col-span-7 h-[280px] sm:h-[350px] md:h-[400px] lg:h-[500px] flex items-center justify-center order-1 lg:order-2">
            <Candlestick3D />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
